// extracted by mini-css-extract-plugin
module.exports = {"main":"Push_main__PDwqB","content":"Push_content__hmI9m","icon":"Push_icon__mS1oI","badge":"Push_badge__N8UxZ"};